import Vue from 'vue';
import VModal from 'vue-js-modal';
import VueAnalytics from 'vue-analytics';

import App from './App.vue';
import router from './router';
import store from './store';


Vue.config.productionTip = false;
Vue.use(VModal);

Vue.directive('scroll', {
  inserted(el, binding) {
    // eslint-disable-next-line
    const f = function (evt) {
      if (binding.value(evt, el)) {
        window.removeEventListener('scroll', f);
      }
    };
    window.addEventListener('scroll', f);
  },
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');

// analytics
Vue.use(VueAnalytics, {
  id: 'UA-44722268-1',
  router,
});
